module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table-component",
    attrs: {
      "cellspacing": "0"
    }
  }, [_c('thead', [_c('tr', [_vm._l((_vm.columns), function(key) {
    return _c('th', {
      class: {
        active: _vm.sortKey == key
      },
      on: {
        "click": function($event) {
          return _vm.sortBy(key)
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm._f("capitalize")(key)) + "\n        "), _c('span', {
      staticClass: "arrow",
      class: _vm.sortOrders[key] > 0 ? 'asc' : 'dsc'
    })])
  }), _vm._v(" "), (Object.keys(_vm.actions).length > 0) ? _c('th', [_vm._v(" ")]) : _vm._e()], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredItems), function(entry) {
    return _c('tr', [_vm._l((_vm.columns), function(key) {
      return _c('td', [_vm._v(_vm._s(entry[key]))])
    }), _vm._v(" "), _c('td', _vm._l((_vm.actions), function(urlKey, action) {
      return _c('router-link', {
        attrs: {
          "to": entry[urlKey]
        }
      }, [_vm._v("\n          " + _vm._s(action) + "\n        ")])
    }), 1)], 2)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-795096fa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Table.vue
// module id = 167
// module chunks = 2